$(document).ready(function () {
  // Toggle dropdown on button click
  $(".custom-sorts-btn").click(function () {
    $(this).parent(".custom-sorts").toggleClass("open");
  });

  // Set the initial active value or default value on page load
  const initialSortValue = $('#SortBy').val();
  const activeButton = $(`.custom-sorts-dropdown button[data-val="${initialSortValue}"]`);

  if (activeButton.length) {
    $('.custom-sort-display').text(activeButton.text().trim());
    activeButton.addClass('is-active');
  } else {
    $('.custom-sort-display').text('{{ "products.facets.sort_by_label" | t }}');
  }

  // Handle button click in the custom dropdown
  $('.custom-sorts-dropdown button').on('click', function () {
    const sortValue = $(this).data('val');
    $('#SortBy').val(sortValue).trigger('change');
    $('.custom-sorts-dropdown button').removeClass('is-active');
    $(this).addClass('is-active');
    $('.custom-sort-display').text($(this).text().trim());
  });

  // Toggle facet filter on mobile
  $(".facets__form-vertical#FacetFiltersForm .facets__heading").click(function () {
    $(this).parent("#FacetFiltersForm").toggleClass("open");
  });

  // Flickity safe init functions
  function destroyFlickity($element) {
    if ($element.hasClass("flickity-enabled")) {
      $element.flickity("destroy");
    }
  }

  function reinitFlickityGalleries() {
    const $main = $(".product__media-list-wrap");
    const $thumbs = $(".thumbnail-list-wrap");

    if (!$main.length || !$thumbs.length) return;

    destroyFlickity($main);
    destroyFlickity($thumbs);

    $main.flickity({
      cellAlign: "center",
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      adaptiveHeight: true,
    });

    $thumbs.flickity({
      asNavFor: ".product__media-list-wrap",
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      cellAlign: "center",
    });
  }

  // Init Flickity on first load
  reinitFlickityGalleries();

  // Re-init Flickity when variant changes (Shopify AJAX)
  document.addEventListener("variantChange", () => {
    setTimeout(() => {
      reinitFlickityGalleries();
    }, 300);
  });
});